<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Admissions: PG Engineering (M.E.)"
                   :links="[{title:'Home', url:'/'},{title:'PG Engineering (M.E.)'}]"></page-header>
      <div class="container-2">
        <section class="content ">
          <accordion :activeIndex="0">
            <accordion-tab header="Sanction Intake">
              <sanction-intake class="overflow-x-auto" :programmes="programmes"></sanction-intake>
            </accordion-tab>
            <accordion-tab header="Important Notifications">
              <TabView>
                <TabPanel header="Admission Notification">
                  <iframe src="/static/pdf/admission/ME_ADMISSION_NOTIFICATION_2021-22.pdf" height="600"
                          width="100%"></iframe>
                </TabPanel>
                <TabPanel header="Shceduled 21-22">
                  <iframe src="/static/pdf/admission/ME_Admission_Schedule_____2021-22_.pdf" height="600"
                          width="100%"></iframe>
                </TabPanel>
              </TabView>
            </accordion-tab>
            <accordion-tab header="Eligibility Criteria">
              <div class="space-y-4">
                <Panel header="Maharashtra State Candidature Candidate">
                  <ol class="list-decimal p-4">
                    <li class="ml-6">The Candidate should be an Indian National.</li>
                    <li class="ml-6">Passed Bachelor Degree in the relevant field of Engineering and Technology from All
                      India Council for
                      Technical Education or Central or State Government approved institutions or equivalent, with at
                      least
                      50% marks (at least 45% marks in case of candidates of Backward class categories and persons with
                      disability belonging to Maharashtra State only).
                    </li>
                    <li class="ml-6"> Passed Bachelor Degree in the relevant course of Engineering and Technology as
                      specified in the
                      eligibility criteria for admission to a Post Graduate Degree course of the concerned University
                      for
                      which admission is being sought.
                    </li>
                    <li class="ml-6">
                      Obtained score in Graduates Aptitude Test in Engineering (GATE) conducted by Indian Institute of
                      Technology.
                    </li>
                    <li class="ml-6">
                      For sponsored candidates, minimum of two years of full time work experience in a registered firm/
                      company/industry/ educational and/ or research institute/ any Government Department or Government
                      Autonomous Organization in the relevant field in which admission is being sought.
                    </li>
                  </ol>
                </Panel>
                <Panel
                    header="Children of NRI / OCI / PIO, Children of Indian workers in the Gulf countries, Foreign National">
                  <ol class="list-decimal p-4">
                    <li class="ml-6">Passed Bachelor Degree in the relevant field of Engineering and Technology from All
                      India Council for Technical Education or Central or State Government approved institutions or
                      equivalent, with at least 50% marks.
                    </li>
                    <li class="ml-6"> Passed Bachelor Degree in the relevant course of Engineering and Technology as
                      specified in the
                      eligibility criteria for admission to a Post Graduate Degree course of the concerned University
                      for
                      which admission is being sought.
                    </li>
                    <li class="ml-6"> Any other criterion declared by appropriate authority from time to time.
                    </li>
                  </ol>
                </Panel>
              </div>
            </accordion-tab>
            <accordion-tab header="Documents Required">
              <div class="space-y-4">
                <Panel
                    header="For Open Category Candidates">
                  <ol class="list-decimal p-4">
                    <template v-for="(item,index) in open" :key="index">
                      <li class="ml-6">{{ item }}</li>
                    </template>
                  </ol>
                </Panel>
                <Panel
                    header="For Reserved Category Candidates">
                  <ol class="list-decimal p-4">
                    <template v-for="(item,index) in category" :key="index">
                      <li class="ml-6">{{ item }}</li>
                    </template>
                  </ol>
                </Panel>
              </div>
            </accordion-tab>
            <accordion-tab header="Admission Process">
              <Panel
                  header="For Reserved Category Candidates">
                <ol class="list-decimal p-4">
                  <template v-for="(item,index) in criteria" :key="index">
                    <li class="ml-6">{{ item }}</li>
                  </template>
                </ol>
                <a class="text-sm" href="http://www.dtemaharashtra.gov.in/index.html" target="_blank"><strong>For
                  detailed admission
                  process please visit to
                  http://www.dtemaharashtra.gov.in/index.html.</strong></a>
              </Panel>
            </accordion-tab>
          </accordion>
        </section>
        <div class="sidebar bg-transparent">
          <div class="flex flex-col gap-3 bg-transparent">
            <admission-contact-card v-for="(admissionContact,index) in admissionContacts" :key="index"
                                    :admissionContact="admissionContact"></admission-contact-card>
          </div>
        </div>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>

<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import KeyRecruiters from "@/components/KeyRecruiters";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import SanctionIntake from "@/views/admissions/SanctionIntake";
import AdmissionContactCard from "@/components/AdmissionContactCard";
import Panel from 'primevue/panel';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';

export default {
  name: "FyUg",
  components: {
    NavbarComponent,
    PageHeader,
    FooterComponent,
    KeyRecruiters,
    Accordion,
    AccordionTab,
    SanctionIntake,
    AdmissionContactCard, Panel, TabView, TabPanel
  },
  data() {
    return {
      programmes: [
        {
          name: 'Computer Engineering',
          intake: 18,
          choiceCode: 512424510
        }, {
          name: 'Civil Engineering (Structural Engineering)',
          intake: 24,
          choiceCode: 512421210
        }, {
          name: 'Mechanical Engineering (Heat Power Engineering)',
          intake: 18,
          choiceCode: 512460110
        }, {
          name: 'Electrical Engineering (Power Systems)',
          intake: 24,
          choiceCode: 512490110
        },
      ],
      admissionContacts: [
        {
          name: 'Prof. Gujrathi T. V.',
          designation: 'Admission Coordinator',
          departments: 'Mechanical',
          mobile: '9028186643',
          email: 'tushargujrathi30592@gmail.com'
        },
        {
          name: 'Prof. Chandgude A. S.',
          designation: 'Admission Coordinator',
          departments: 'Computer',
          mobile: '9552218363',
          email: 'amarschandgude1445@gmail.com'
        },
        {
          name: 'Prof. Karale S.A.',
          designation: 'Admission Coordinator',
          departments: 'Civil',
          mobile: '9860305612',
          email: 'sandipakarale@gmail.com'
        },
        {
          name: 'Dr. Tapre P. C.',
          designation: 'Admission Coordinator',
          departments: 'Electrical',
          mobile: '7987331104',
          email: 'pawan.tapre25snd@gmail.com'
        },],
      open: [
        'Allotment Letter',
        'Gate Score card/ Sponsorship Letter',
        'Degree Marksheet',
        'Statement of Marks – SSC (10th)',
        'Statement of Marks – HSC (12th) (if applicable)',
        'Final year diploma mark sheet (if applicable)',
        'Leaving Certificate / Transfer Certificate',
        'Migration Certificate (if applicable)',
        'Certificate of Indian Nationality in the name of the Candidate',
        'Domicile Certificate (if applicable), clearly indicating the place of Permanent Residence of the Candidate / Father or Mother or Husband',
        'Aadhar Card',
        'Gap Certificate (if applicable)',
      ],
      category: [
        'Allotment Letter',
        'Gate Score card/ Sponsorship Letter',
        'Diploma /Degree Mark sheet',
        'Statement of Marks – SSC (10th)',
        'Statement of Marks – HSC (12th) (If applicable)',
        'Final year diploma mark sheet (if applicable)',
        'Leaving Certificate / Transfer Certificate',
        'Migration Certificate (if applicable)',
        'Certificate of Indian Nationality in the name of the Candidate',
        'Domicile Certificate (if applicable), clearly indicating the place of Permanent Residence of the Candidate / Father or Mother or Husband',
        'Aadhar Card',
        'Cast Certificate',
        'Cast Validity',
        'Non – Creamy Layer Certificate valid up to 31st March 2021 (if applicable)',
        'Gap Certificate (if applicable)',
      ],
      criteria: [
        'Publishing of information brochure by state CET cell.',
        'Filling online application form by candidate for participation in the Centralised Admission Process (CAP)',
        'Document verification at facilitation centre by the candidate.',
        'Publishing of provisional merit lists, submission of grievances, if any, and publishing of final merit list.',
        'Display of available category wise Seat Matrix for CAP Round I',
        'Filling up and confirmation of online option form having preferences of courses and institutions before CAP Round I. The option form once confirmed shall be considered for allotment in CAP Round I',
        'Display of Provisional allotment of CAP Round I indicating allotted institute and course.',
        'Reporting and confirmation of admission to the allotted institute by paying fee and submitting original documents.',
        'The students those have not confirmed the allotted seat in CAP round-I or not received any allotment in CAP round –I are eligible for further CAP rounds.',
        'Same process is applicable for CAP round II &III',
      ]
    }
  }
}
</script>

<style scoped>

</style>
